import { useCallback, useEffect, useMemo, useRef } from 'react';
import { ECollectionBannerState } from '../types';
import { useCompletedCollection } from '../ownedCollections';
import { useCollectionProgress } from '../collectionProgress';
import useNextInvalidationTimestamp from '../../../hooks/useNextInvalidationTimestamp';
var useCollectionState = function (collectionIdOrAlias) {
    var progress = useCollectionProgress(collectionIdOrAlias);
    var collectionRef = useRef(null);
    useEffect(function () {
        var _a;
        collectionRef.current = (_a = progress === null || progress === void 0 ? void 0 : progress.collection) !== null && _a !== void 0 ? _a : null;
    }, [progress === null || progress === void 0 ? void 0 : progress.collection]);
    var getNextInvalidationTimestamp = useCallback(function () {
        var collection = collectionRef.current;
        if (!collection) {
            return null;
        }
        if (Date.now() < Date.parse(collection.availableFrom)) {
            return Date.parse(collection.availableFrom) + 100;
        }
        if (Date.now() < Date.parse(collection.availableUntil)) {
            return Date.parse(collection.availableUntil) + 100;
        }
        return null;
    }, []);
    var nextInvalidationTimestamp = useNextInvalidationTimestamp(getNextInvalidationTimestamp);
    var completedCollection = useCompletedCollection(collectionIdOrAlias);
    return useMemo(function () {
        var _a;
        if (completedCollection || ((_a = progress === null || progress === void 0 ? void 0 : progress.progress) === null || _a === void 0 ? void 0 : _a.status) === 'completed') {
            return ECollectionBannerState.COMPLETED;
        }
        if (!(progress === null || progress === void 0 ? void 0 : progress.collection)) {
            return null;
        }
        if (Date.now() < Date.parse(progress.collection.availableFrom)) {
            return ECollectionBannerState.UPCOMING;
        }
        if (Date.now() > Date.parse(progress.collection.availableUntil)) {
            return ECollectionBannerState.EXPIRED;
        }
        return ECollectionBannerState.AVAILABLE;
        // eslint-disable-next-line
    }, [
        collectionIdOrAlias,
        completedCollection,
        progress === null || progress === void 0 ? void 0 : progress.collection,
        nextInvalidationTimestamp,
    ]);
};
export default useCollectionState;
